module.exports = __webpack_public_path__ + "static/media/Success image.b2f7ae20.png";